/* Grove Walls: wishlist saved in the visitor's browser (no app, no account needed).
   Stores product handles, keeps every heart button and the header counter in sync,
   and exposes window.GroveWishlist for the wishlist page. */
(function () {
  var KEY = 'grove-wishlist-v1';
  var MAX = 60;
  var toastTimer;

  function read() {
    try {
      var list = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(list) ? list.filter(function (h) { return typeof h === 'string' && h; }) : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX)));
    } catch (e) {}
    sync();
    document.dispatchEvent(new CustomEvent('grove:wishlist-change', { detail: { items: read() } }));
  }

  function has(handle) {
    return read().indexOf(handle) !== -1;
  }

  function add(handle) {
    var list = read().filter(function (h) { return h !== handle; });
    list.unshift(handle);
    write(list);
  }

  function remove(handle) {
    write(read().filter(function (h) { return h !== handle; }));
  }

  function addMany(handles) {
    var list = read();
    handles.slice().reverse().forEach(function (handle) {
      if (list.indexOf(handle) === -1) list.unshift(handle);
    });
    write(list);
  }

  /* Only touch text when it changes, so the MutationObserver below does not loop */
  function setText(el, value) {
    if (el.textContent !== value) el.textContent = value;
  }

  function sync() {
    var list = read();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (button) {
      var saved = list.indexOf(button.getAttribute('data-handle')) !== -1;
      button.setAttribute('aria-pressed', saved ? 'true' : 'false');
      var label = button.getAttribute(saved ? 'data-label-remove' : 'data-label-add');
      if (label) button.setAttribute('aria-label', label);
      var text = button.querySelector('[data-wishlist-label]');
      if (text) setText(text, saved ? 'Saved to your wishlist' : 'Save to wishlist');
    });
    document.querySelectorAll('.grove-links__icon[href="/pages/wishlist"]').forEach(function (link) {
      var badge = link.querySelector('.grove-wl-count');
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'grove-wl-count';
        badge.setAttribute('aria-hidden', 'true');
        link.appendChild(badge);
      }
      setText(badge, list.length > 99 ? '99+' : String(list.length));
      badge.hidden = list.length === 0;
      link.setAttribute('aria-label', list.length ? 'Wishlist (' + list.length + ' saved)' : 'Wishlist');
    });
  }

  function toast(saved) {
    var el = document.querySelector('.grove-wl-toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'grove-wl-toast';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      document.body.appendChild(el);
    }
    el.innerHTML = saved
      ? '<span>Saved to your wishlist</span><a href="/pages/wishlist">View</a>'
      : '<span>Removed from your wishlist</span>';
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-visible'); }, 2800);
  }

  /* Capture phase so the click never reaches the product card link behind the heart */
  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-wishlist-toggle]');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    var handle = button.getAttribute('data-handle');
    if (!handle) return;
    if (has(handle)) {
      remove(handle);
      toast(false);
    } else {
      add(handle);
      toast(true);
      button.classList.remove('is-popping');
      void button.offsetWidth;
      button.classList.add('is-popping');
    }
  }, true);

  /* Other tabs */
  window.addEventListener('storage', function (event) {
    if (event.key === KEY) sync();
  });

  /* Cards loaded later (filters, infinite scroll, quick add) */
  var pending;
  new MutationObserver(function () {
    clearTimeout(pending);
    pending = setTimeout(sync, 120);
  }).observe(document.documentElement, { childList: true, subtree: true });

  window.GroveWishlist = { read: read, add: add, remove: remove, addMany: addMany, has: has, clear: function () { write([]); } };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
})();
